var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkDataUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8152_8302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5L16 12.5H13V3.5H11V12.5H8L12 16.5ZM21 3.5H15V5.49H21V19.52H3V5.49H9V3.5H3C1.9 3.5 1 4.4 1 5.5V19.5C1 20.6 1.9 21.5 3 21.5H21C22.1 21.5 23 20.6 23 19.5V5.5C23 4.4 22.1 3.5 21 3.5Z",
    fill: "gray"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8152_8302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkDataUpdate);
export default __webpack_public_path__ + "static/media/Bulk_Data_Update.2a95ad1d21c1709c71fd7bf5761019ea.svg";
export { ForwardRef as ReactComponent };